/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Botica API
 * API for the Botica professional network for Venezuelan pharmacists
 * OpenAPI spec version: v1
 */
import type {
  AdminReportDto,
  AdminReportListResponse,
  GetApiAdminReportsParams,
  ReviewReportRequest
} from '../boticaAPI.schemas';

import { axiosInstance } from '../../axiosInstance';



  export const getAdminReports = () => {
const getApiAdminReports = (
    params?: GetApiAdminReportsParams,
 ) => {
      return axiosInstance<AdminReportListResponse>(
      {url: `/api/admin/reports`, method: 'GET',
        params
    },
      );
    }
  const getApiAdminReportsId = (
    id: string,
 ) => {
      return axiosInstance<AdminReportDto>(
      {url: `/api/admin/reports/${id}`, method: 'GET'
    },
      );
    }
  const postApiAdminReportsIdReview = (
    id: string,
    reviewReportRequest: ReviewReportRequest,
 ) => {
      return axiosInstance<AdminReportDto>(
      {url: `/api/admin/reports/${id}/review`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reviewReportRequest
    },
      );
    }
  return {getApiAdminReports,getApiAdminReportsId,postApiAdminReportsIdReview}};
export type GetApiAdminReportsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminReports>['getApiAdminReports']>>>
export type GetApiAdminReportsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminReports>['getApiAdminReportsId']>>>
export type PostApiAdminReportsIdReviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAdminReports>['postApiAdminReportsIdReview']>>>
